const angular = require('angular');
const app = angular.module('learn-services');
const moment = require('moment');
app.factory('Authorization', ['Access', 'appConfiguration', 'AuthorizationResource', 'Storage', 'NPS', 'Intercom', 'Navigation', 'Notifications', '$timeout', '$rootScope', '$location', function(Access, appConfiguration, AuthorizationResource, Storage, NPS, Intercom, Navigation, Notifications, $timeout, $rootScope, $location) {
    var self = this;

    /**
     * Authorization control object
     * @type authorization
     */
    self.authorization = {
      onBeforeExpiresSubscribers: [],
      onBeforeExpires: function(authtoken) {
        self.authorization.onBeforeExpiresSubscribers.forEach(function(subscriber) {
          if (typeof subscriber === 'function') {
            subscriber.call(this, authtoken);
          }
          if (typeof subscriber === 'object') {
            subscriber.onBeforeExpires(authtoken);
          }
        });
      },
      onBeforeExpiresClearSubscribers: function() {
        self.authorization.onBeforeExpiresSubscribers.length = 0;
      },
      onBeforeExpiresSubscribe: function(subscriber) {
        self.authorization.onBeforeExpiresSubscribers.push(subscriber);
      },
      getAuthToken: function() {
        return Access.getAuthtoken();
      },
      saveAuthToken: function(token, skipActiveSetting) {
        if (token === null) {
          return false;
        }
        Access.setAuthtoken(token);
        Storage.put('authtoken', token);
        if (!skipActiveSetting) {
          self.authorization.setActive();
        }
        return true;
      },
      updateImage: function(type, image) {
        var token = self.authorization.getAuthToken();
        if (!token || !token.user) {
          return;
        }
        if (type === 'image') {
          token.user.image = image;
        }
        if (type === 'banner_image') {
          token.user.image = image;
        }
        self.authorization.saveAuthToken(token);
      },
      clearAuthToken: function() {
        Storage.put('last_active', null);
        Storage.remove('authtoken');

        // Also remove what the learners app relies on.
        Storage.remove('authStore');
        Storage.remove('exploreStore');

        Intercom.shutdown();
        NPS.remove();
        Access.removeAuthtoken();
        if (self.authorization.stopAuthTokenRefresh) {
          $timeout.cancel(self.authorization.stopAuthTokenRefresh);
          self.authorization.stopAuthTokenRefresh = undefined;
        }
        if (self.authorization.stopTTLVerification) {
          $timeout.cancel(self.authorization.stopTTLVerification);
          self.authorization.stopTTLVerification = undefined;
        }
      },
      hasValidAuthToken: function(declineActivity) {
        var now = new Date();
        var token = self.authorization.getAuthToken();
        var last_active = Storage.get('last_active');

        if (token === undefined || token === null || !token.authtoken) {
          self.authorization.clearAuthToken();
          return false;
        }

        if (!declineActivity && (!last_active || now.valueOf() > last_active)) {
          self.authorization.clearAuthToken();
          return false;
        }
        // TTL = config.continu.authTokenTTL = 18000 * 1000 = 5hr | creating expires on 
        var expiresOn = new Date(token.createdOn + (token.ttl));
        if ((expiresOn === undefined || expiresOn === null) || (now >= expiresOn)) {
          self.authorization.clearAuthToken();
          return false;
        }

        return true;
      },
      stopAuthTokenRefresh: undefined,
      launchAuthTokenRefresh: function() {
        if (self.authorization.stopAuthTokenRefresh) {
          return;
        }
        var token = self.authorization.getAuthToken();
        var now = new Date();
        var expiresOnMinusFiveMinutes = new Date(token.createdOn + (token.ttl - appConfiguration.learnAppBeforeExpiresRefreshTokenMS));
        self.authorization.stopAuthTokenRefresh = $timeout(function() {
          // TTL = config.continu.authTokenTTL = 18000 * 1000 = 5hr | creating expires on 
          if (self.authorization.hasValidAuthToken() && (new Date()) >= expiresOnMinusFiveMinutes) {
            AuthorizationResource.refresh({}, {}, function(data) {
              var refreshedToken = Object.assign({}, token, data);
              self.authorization.saveAuthToken(refreshedToken);
              if (self.authorization.stopAuthTokenRefresh) {
                $timeout.cancel(self.authorization.stopAuthTokenRefresh);
                self.authorization.stopAuthTokenRefresh = undefined;
                self.authorization.launchAuthTokenRefresh();
              }
            }, function(error) {
              console.log('Could not refresh token.', error);
            });
          }
        }, expiresOnMinusFiveMinutes.getTime() - now.getTime());
      },
      stopTTLVerification: undefined,
      launchTTLVerification: function() {
        if (self.authorization.stopTTLVerification) {
          return;
        }
        var token = self.authorization.getAuthToken();
        if (token === null) {
          return;
        }
        var now = new Date();
        // TTL = config.continu.authTokenTTL = 18000 * 1000 = 5hr | creating expires on 
        var expiresOn = new Date(token.createdOn + token.ttl);
        if ((expiresOn === undefined || expiresOn === null) || (now >= expiresOn)) {
          return;
        }

        var millisecondsToWait = expiresOn.getTime() - now.getTime() + 5;

        self.authorization.stopTTLVerification = $timeout(function() {
          if (!self.authorization.hasValidAuthToken()) {
            self.authorization.onBeforeExpires(token);
            // clearAuthToken call $timeout.cancel with stopTTLVerification
            self.authorization.clearAuthToken();
            Notifications.setError("Credentials Expired - please sign in again.");
            Navigation.goToSignIn();
          }
        }, millisecondsToWait);
      },
      validateAndUseAuthToken: function(token) {
        // save
        if (!self.authorization.saveAuthToken(token)) {
          return false;
        }
        // verify validity
        // Not concerned with last active here
        if (!self.authorization.hasValidAuthToken(true)) {
          return false;
        }

        // start ttl refresh and check
        self.authorization.launchAuthTokenRefresh();
        self.authorization.launchTTLVerification();
        Intercom.bootUser();

        if (!NPS.hasBeenAdded && !NPS.beingAdded) {
          NPS.add();
        }
        

        return true;
      },
      signout: function(noRedirect) {
        self.authorization.clearAuthToken();
        if (noRedirect) {
          return;
        }

        var preRedirect = Navigation.getPath();
        var redirectParams = Navigation.getUrlParameters();
        if (preRedirect === '/resetpassword') {
          return;
        }
        if (preRedirect && Navigation.isRouteSecure(preRedirect) && preRedirect !== '/explore') {
          Storage.put('preRedirect', preRedirect);
          if (redirectParams) {
            Storage.put('redirectParams', redirectParams);
          }
        }

        $location.path('/signin');

        if(!$rootScope.$$phase) {
          $rootScope.$apply();
        }
      },
      inactiveTimeout: null,
      setActive: function() {
        Storage.put('last_active', (new Date().valueOf() + appConfiguration.learnAppActivityTTL));
        clearTimeout(self.authorization.inactiveTimeout);

        function reset(duration) {
          duration = duration || appConfiguration.learnAppActivityTTL;
          return setTimeout(function() {

            var last_active = Storage.get('last_active');
            if (last_active && new Date().valueOf() < last_active) {
              self.authorization.inactiveTimeout = reset(moment(last_active).diff(moment()));
              return;
            }

            self.authorization.signout();

          }, duration);
        }
        self.authorization.inactiveTimeout = reset();
      },
      isAdmin: function() {
        if (!self.authorization.hasValidAuthToken()) {
          return false;
        }
        return self.authorization.getAuthToken().user?.role === 'admin';
      },
      isCreator: function() {
        if (!self.authorization.hasValidAuthToken()) {
          return false;
        }
        return self.authorization.getAuthToken().user?.role === 'creator';
      },
      isCollaborator: function() {
        if (!self.authorization.hasValidAuthToken()) {
          return false;
        }
        if (!self.authorization.getAuthToken().user) {
          return false;
        }
        if (self.authorization.getAuthToken().user.role !== 'user') {
          return false;
        }
        return (self.authorization.getAuthToken().user.is_collaborator === true);
      },
      isManager: function() {
        if (!self.authorization.hasValidAuthToken()) {
          return false;
        }
        if (!self.authorization.getAuthToken().user) {
          return false;
        }
        if (self.authorization.getAuthToken().user.role !== 'user') {
          return false;
        }
        return (self.authorization.getAuthToken().user.is_manager === true);
      },
      activityCheck: function() {
        // Don't run this check for users that already have an invalid token.
        if (!Navigation.isRouteSecure()) {
          return;
        }
        const accessAuthToken = Access.getAuthtoken();
        if (!accessAuthToken || !accessAuthToken.authtoken) {
          return;
        }

        // last_active is a local storage value that is used for tracking timeout behavior - set initially from config (default 4 hours)
        // last_active is updated on the $routeChangeSuccess event - resetting the window (default 4 hours)
        // this activity check is run automated on the angular $routeChangeStart event to validate current activity state has not passed. It is also run when window status changes to account for timeout behaviors
        var last_active = Storage.get('last_active');
        if (!last_active || new Date().valueOf() > last_active) {
          self.authorization.signout();
        }
      }
    };

    return self.authorization;
  }]);